import {writable} from "../web_modules/svelte/store.js";
export const folded = createFolded();
function createFolded() {
  const {subscribe, set, update} = writable(true);
  return {
    subscribe,
    toggle: () => update((v) => !v),
    expand: () => set(false),
    fold: () => set(true)
  };
}
//# sourceMappingURL=navigation.js.map
